import { clientFetch } from '@biw/client-fetch';

import { Dispatch } from 'app/types/redux';
import { routeTo } from 'dux/router/actions';

import * as types from './types';

// const { authType } = constants;

/******************
 * Initial state
 */
export const userState = {
    hasOts: false,
};

let initialState: any;
try {
    initialState = JSON.parse( sessionStorage.getItem( 'userState' ) || '' ) || userState;
} catch {
    initialState = userState;
}

/******************
 * Non-async action types
 */
export const SET_USER_DATA = 'setUserData';
const VALIDATE_SESSION = 'validateSession';
const SET_AUTH_TYPE = 'SET_AUTH_TYPE';
const SET_LANGUAGE_OVERRIDE = 'USER_SET_LANGUAGE_OVERRIDE';

/******************
 * Reducer
 */
export default function user( state = initialState, action: any ) {
    let newState = state;
    switch ( action.type ) {
        case types.SET_USER_DATA:
            newState = {
                ...state,
                ...action.user,
            };
            break;

        // TODO: probably don't need this any longer
        case SET_AUTH_TYPE:
            newState = {
                ...state,
                authType: action.authType,
            };
            break;
        case types.USER_LOGOUT:
            newState = { ...userState };
            break;

        case SET_LANGUAGE_OVERRIDE:
            newState = {
                ...newState,
                loginLanguageOverride: action.payload,
            };
            break;
    }

    return newState;
}

/******************
 * Action creators
 */

export const getUserData = () => ( dispatch: Dispatch, getState: any ) => {
    // const sessionId = sessionStorage.getItem( 'sessionId' );
    // if ( sessionId ) {
    //     setSessionId( sessionId );
    //     return clientFetch( {
    //         url: '/api/v1.0/user',
    //         catchError: true
    //     } ).then( ( user ) => {
    //         if ( user.responseCode ) {
    //             throw new Error( 'User is not authenticated' );
    //         }
    //         dispatch( setUserData( {
    //             ...user,
    //             sessionId,
    //             authenticated: true
    //         } ) );
    //     } ).catch( err => dispatch( routeTo( '/logout' ) ) );
    // }
};

export const setLanguageOverrideFlag = ( flag = false ) => ( {
    type: SET_LANGUAGE_OVERRIDE,
    payload: flag,
} );

export function setActiveProgram( program = {} as any ) {
    return ( dispatch: Dispatch, getState: any ) => {
        if ( !program.programViewId ) {
            return dispatch( routeTo( '/profile' ) );
        }
        let url = `/program-view/${program.programViewId}`;
        if ( program.section ) {
            url = `${url}#${program.section}`;
        }
        dispatch( routeTo( url ) );
    };
}

export const setAuthType = ( authType: any ) => {
    return {
        type: SET_AUTH_TYPE,
        authType,
    };
};

export const validateSession = () => {
    return ( dispatch: Dispatch, getState: any ) => {
        const userId = getState().user.userId;
        if ( userId ) {
            return clientFetch( {
                url: '/api/v1.0/validSession',
                type: VALIDATE_SESSION,
                catchError: true,
            } ).catch( ( error: Error ) => {
                const errorCode = JSON.parse( error.message ).responseCode;
                if ( errorCode && errorCode === 401 ) {
                    dispatch( routeTo( '/logout' ) );
                }
            } );
        } else {
            dispatch( routeTo( '/logout' ) );
        }
    };
};
